import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  Box,
  CircularProgress,
  ClickAwayListener,
  Grid,
  List,
  ListItemButton,
  ListItemText,
  MenuItem,
  Paper,
  Popper,
  Stack,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import axios from "axios";
import moment from "moment";
import { memo, useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CustomCheckBox from "../../../components/checkbox";
import Label from "../../../components/label";
import CustomDropDown from "../../../components/select";
import TextInput from "../../../components/textInput";
import { AppContext } from "../../../lib/Context";
import { setPhoneValidation } from "../../../lib/redux/slices/phoneValidationSlice";
import { customerPhoneValidation } from "../../../services/WebUser";
import {
  formatPhoneForDisplay,
  handleOpenSnackBar,
} from "../../../utils/helper";
import useDebounce from "./../../../components/hooks/useDebounce";
import VerifiedIcon from "@mui/icons-material/Verified";
import GppMaybeIcon from "@mui/icons-material/GppMaybe";
import { getAllAgents } from "../../../services/AgentApi";

const agentList = ["1A", "1B", "1C", "1D", "1E", "1F"];
const ownerList = ["Owner", "Director", "Company Secretary"];
const title = ["Mr", "Mrs", "Miss", "Ms", "Dr", "Prof", "Rev", "Hon", "Eng"];
const currentProvider = [
  "New Installation",
  "BT Group",
  "Vodafone UK",
  "Sky UK",
  "TalkTalk Business",
  "Virgin Media Business",
  "Daisy Group",
  "Gamma Telecom",
  "Zen Internet",
  "KCOM Group",
  "Hyperoptic",
  "Plusnet Business",
  "XLN Telecom",
  "Utility Warehouse",
  "Community Fibre",
  "bOnline",
  "Cuckoo",
  "YouFibre",
  "CityFibre",
  "Giganet",
  "Swish Fibre",
  "Clear Business",
  "4Comm",
  "Uniplus",
  "Trust Telecom",
  "Onecom",
];

const useStyle = {
  datePickerStyle: {
    width: "100%",
    "&.MuiFormControl-root .MuiInputBase-root": {
      borderRadius: "4px",
      backgroundColor: "#d4ecff87",
      borderLeft: "none",
    },
  },
};

const GeneralConnections = () => {
  const {
    userData,
    generalInfo,
    setGeneralInfo,
    contractLength,
    isBillingEmailSame,
    setIsBillingEmailSame,
    accountNo,
    setAccountNo,
  } = useContext(AppContext);

  const location = useLocation();
  const isAdmin = userData?.designation === "Admin" ? true : false;
  const isDetailPage = location.pathname === "/prospect-details";
  const createdBy = location.pathname === "/add-lead-admin" ? "Admin" : "Agent";

  const inputRef = useRef(null);
  const disptch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const debounceTerm = useDebounce(searchValue, 1000);
  const [addresses, setAddresses] = useState([]);
  const [allAgents, setAllAgents] = useState([]);
  const { phoneValidation } = useSelector(
    (state) => state.phoneValidationReducer
  );


  useEffect(() => {
    getAddresses();
  }, [debounceTerm]);

  const getAddresses = async () => {
    try {
      if (!debounceTerm) return;
      setIsLoading(true);

      const baseUrl =
        "https://services.postcodeanywhere.co.uk/Capture/Interactive/Find/v1.10/json3.ws";
      const apiKey = "YZ17-GD31-UB82-BF71";

      const res = await axios.get(baseUrl, {
        params: {
          Key: apiKey,
          Text: debounceTerm,
          Origin: "GBR",
        },
      });

      const items = res?.data?.Items || [];
      let finalAddresses = [];

      for (const item of items) {
        if (item.Type === "Address") {
          finalAddresses.push(item);
        } else if (item.Type === "Container") {
          try {
            const childRes = await axios.get(baseUrl, {
              params: {
                Key: apiKey,
                Container: item.Id,
                Origin: "GBR",
              },
            });
            const childItems = childRes?.data?.Items || [];
            finalAddresses.push(...childItems);
          } catch (err) {
            console.error("Error fetching child addresses:", err);
          }
        }
      }

      setAnchorEl(inputRef.current);
      setAddresses(finalAddresses);
    } catch (error) {
      console.error("Main error:", error);
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFetchFormatedAddress = async (data) => {
    if (!data) return;

    const formatedAddress = `${data.Text}`;

    if (data.Type === "Container") {
      setGeneralInfo((prev) => ({
        ...prev,
        address1: formatedAddress,
        town: "",
        city: "",
        postCode: "",
      }));
    } else if (data.Id && data.Type === "Address") {
      try {
        setIsLoading(true);
        const response = await axios.get(
          `https://services.postcodeanywhere.co.uk/capture/interactive/retrieve/v1.2/json3.ws`,
          {
            params: {
              Key: "YZ17-GD31-UB82-BF71",
              Id: data.Id,
            },
          }
        );

        if (response.data?.Items?.length > 0) {
          const addressData = response.data.Items.find((x) => x.Id === data.Id);

          if (addressData) {
            setGeneralInfo((prev) => ({
              ...prev,
              // address1: addressData.Label?.replace(/\n/g, " "),
              address1: formatedAddress,
              town: addressData.District,
              city: addressData.City,
              postCode: addressData.PostalCode,
            }));
          } else {
            setGeneralInfo((prev) => ({
              ...prev,
              address1: formatedAddress,
              town: "",
              city: "",
              postCode: "",
            }));
          }
        }
      } catch (error) {
        console.error("Loqate fetch error", error);
        setGeneralInfo((prev) => ({
          ...prev,
          address1: formatedAddress,
          town: "",
          city: "",
          postCode: "",
        }));
      } finally {
        setIsLoading(false);
      }
    } else {
      setGeneralInfo((prev) => ({
        ...prev,
        address1: formatedAddress,
        town: "",
        city: "",
        postCode: "",
      }));
    }
  };

  useEffect(() => {
    if (userData && userData?.designation === "Admin") {
      handleFetchAllGents();
    }

    if (userData && userData?.designation === "Sales Agent") {
      setGeneralInfo((prev) => ({
        ...prev,
        agent:
          userData.designation === "Admin"
            ? generalInfo.agent
            : userData.username,
      }));
    }
  }, [userData, contractLength]);

  const handleChangeValue = (event) => {
    let { name, value } = event.target;

    let formattedValue = value;

    if (name === "mobileNo") {
      disptch(setPhoneValidation(null));

      // Remove non-digit characters (like spaces) before processing
      const cleanedValue = value.replace(/\D/g, "");
      if (cleanedValue.length > 11) return;

      if (cleanedValue.length === 11) {
        verifyPhoneNumber(cleanedValue);
      }

      formattedValue = cleanedValue;
    }

    if (name !== "email" && name !== "billingEmail" && name !== "mobileNo") {
      formattedValue = value.replace(/\b[a-zA-Z]/g, (char) =>
        char.toUpperCase()
      );
    }

    setGeneralInfo({ ...generalInfo, [name]: formattedValue });
  };

  const verifyPhoneNumber = async (phoneNumber) => {
    try {
      setIsLoading1(true);
      const response = await customerPhoneValidation(phoneNumber);
      if (response.data.status === "success") {
        const data = response.data.data;
        disptch(setPhoneValidation(data));
        if (data.IsValid === "Yes") {
          handleOpenSnackBar("success", "Mobile number verified successfully");
        } else {
          handleOpenSnackBar("error", "Mobile number validation failed");
        }
      } else {
        disptch(setPhoneValidation(null));
        handleOpenSnackBar("error", "Mobile number validation failed");
      }
    } catch (error) {
      handleOpenSnackBar("error", "Mobile number validation failed");
    } finally {
      setIsLoading1(false);
    }
  };

  const handleFetchAllGents = async () => {
    try {
      const response = await getAllAgents();
      if (response?.data.status === "success") {
        let data = response.data.data;
        setAllAgents(data);
      }
    } catch (error) {
      console.error("error", error?.message);
    }
  };

  const handleChangeAgent = (e) => {
    const value = e.target.value;
    const findAgent = allAgents.find((x) => x._id === value);
    setGeneralInfo((prev) => ({
      ...prev,
      agent: findAgent.username,
      agentId: value,
    }));
  };


  return (
    <Box my={3}>
      <Grid container mt={2} spacing={2}>
        <Grid item xs={12} mb={3}>
          <Grid container spacing={2}>
            {(location.pathname === "/edit-lead" ||
              location.pathname === "/prospect-details") &&
              location &&
              location?.state?.data?.status === "envelope-completed" && (
                <Grid item xs={12} sm={6} md={3}>
                  <Label title={"Account Number"} />
                  <TextInput
                    variant="filled"
                    type={"number"}
                    readonly={!isAdmin || isDetailPage}
                    placeholder={"Enter Account Number"}
                    value={accountNo}
                    onChange={(e) => setAccountNo(e.target.value)}
                  />
                </Grid>
              )}

            {createdBy === "Admin" ? (
              <Grid item xs={12} sm={6} md={3}>
                <Label title={"Select Agent"} htmlFor={"select-agent"} />
                <CustomDropDown
                  id={"select-agent"}
                  required
                  variant={"filled"}
                  value={generalInfo.agentId}
                  name={"agentId"}
                  onChange={handleChangeAgent}
                  readonly={isDetailPage}
                >
                  {allAgents.map((val, ind) => {
                    return (
                      <MenuItem key={ind} value={val._id}>
                        {val.username}
                      </MenuItem>
                    );
                  })}
                </CustomDropDown>
              </Grid>
            ) : (
              <Grid item xs={12} sm={6} md={3}>
                <Label title={"Agent"} htmlFor={"agent-name"} />
                <TextInput
                  id={"agent-name"}
                  readonly
                  required
                  variant={"filled"}
                  placeholder={"Enter agent name"}
                  value={generalInfo.agent}
                  name={"agent"}
                  onChange={handleChangeValue}
                />
              </Grid>
            )}

            <Grid item xs={12} sm={6} md={3}>
              <Label title={"Date"} htmlFor={"date"} />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TextInput
                  id={"date"}
                  type={"text"}
                  readonly
                  required
                  variant={"filled"}
                  value={moment(generalInfo?.signupDate).format(
                    "DD.MM.YY [at] HH:MM"
                  )}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Label title={"Live Date"} htmlFor={"live-date"} />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  sx={useStyle.datePickerStyle}
                  value={generalInfo?.liveDate}
                  readOnly={isDetailPage || !isAdmin}
                  format="DD.MM.YY"
                  disablePast={true}
                  onChange={(newValue) =>
                    setGeneralInfo((prev) => ({ ...prev, liveDate: newValue }))
                  }
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Current Provider"} htmlFor={"current-provider"} />
          <CustomDropDown
            id={"current-provider"}
            required
            variant={"filled"}
            value={generalInfo.currentProvider}
            name={"currentProvider"}
            onChange={handleChangeValue}
            readonly={isDetailPage}
          >
            {currentProvider.map((val, ind) => {
              return (
                <MenuItem key={ind} value={val}>
                  {val}
                </MenuItem>
              );
            })}
          </CustomDropDown>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Title"} htmlFor={"customer-title"} />
          <CustomDropDown
            id={"customer-title"}
            required
            variant={"filled"}
            value={generalInfo.title}
            name={"title"}
            onChange={handleChangeValue}
            readonly={isDetailPage}
          >
            {title.map((val, ind) => {
              return (
                <MenuItem key={ind} value={val}>
                  {val}
                </MenuItem>
              );
            })}
          </CustomDropDown>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Customer Name"} htmlFor={"customer-name"} />
          <TextInput
            id={"customer-name"}
            required
            variant={"filled"}
            value={generalInfo.name}
            name={"name"}
            onChange={handleChangeValue}
            readonly={isDetailPage}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Designation"} htmlFor={"customer-designation"} />
          <CustomDropDown
            id={"customer-designation"}
            required
            variant={"filled"}
            value={generalInfo.designation}
            name={"designation"}
            onChange={handleChangeValue}
            readonly={isDetailPage}
          >
            {ownerList.map((val, ind) => {
              return (
                <MenuItem key={ind} value={val}>
                  {val}
                </MenuItem>
              );
            })}
          </CustomDropDown>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Customer Email"} htmlFor={"customer-email"} />
          <TextInput
            id={"customer-email"}
            required
            variant="filled"
            value={generalInfo.email}
            name={"email"}
            onChange={handleChangeValue}
            readonly={isDetailPage}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Mobile number"} htmlFor={"customer-contact"} />
          <TextInput
            id={"customer-contact"}
            required
            variant="filled"
            type="text"
            value={formatPhoneForDisplay(generalInfo.mobileNo)}
            name={"mobileNo"}
            onChange={handleChangeValue}
            readonly={isDetailPage}
            InputEndIcon={
              isLoading1 ? (
                <CircularProgress size={24} />
              ) : phoneValidation?.IsValid === "Yes" ? (
                <VerifiedIcon htmlColor="green" />
              ) : phoneValidation?.IsValid === "No" ? (
                <GppMaybeIcon htmlColor="red" />
              ) : null
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Business Name"} htmlFor={"customer-business-name"} />
          <TextInput
            id={"customer-business-name"}
            required
            variant="filled"
            value={generalInfo.businessName}
            name={"businessName"}
            onChange={handleChangeValue}
            readonly={isDetailPage}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Business Type"} htmlFor={"customer-business-type"} />
          <TextInput
            id={"customer-business-type"}
            required
            variant="filled"
            value={generalInfo.businessType}
            name={"businessType"}
            onChange={handleChangeValue}
            readonly={isDetailPage}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={3} position={"relative"}>
          <Label title={"Search Address"} htmlFor={"addresses"} />
          <TextInput
            id={"addresses"}
            required
            variant="filled"
            value={searchValue}
            name={"address1"}
            onChange={(e) => setSearchValue(e.target.value)}
            readonly={isDetailPage}
            InputEndIcon={isLoading && <CircularProgress size={24} />}
          />
          <Box ref={inputRef}></Box>
          <Popper
            open={addresses?.length > 0}
            anchorEl={anchorEl}
            placement="bottom-start"
            style={{
              zIndex: 1500,
              width: inputRef.current?.clientWidth,
            }}
          >
            <ClickAwayListener onClickAway={() => setAddresses([])}>
              <Paper
                sx={{
                  width: "100%",
                  maxHeight: "200px",
                  overflowY: "auto",
                  backgroundColor: "background.paper",
                }}
              >
                <List>
                  {addresses.map((add) => (
                    <ListItemButton
                      key={add.Id}
                      onClick={() => {
                        handleFetchFormatedAddress(add);
                        setAddresses([]);
                        setSearchValue("");
                      }}
                    >
                      <ListItemText
                        primary={`${add.Text} ${add.Description}`}
                      />
                    </ListItemButton>
                  ))}
                </List>
              </Paper>
            </ClickAwayListener>
          </Popper>
        </Grid>
        <Grid item xs={12} sm={12} md={9}>
          <Label
            title={"1st Line of Phone Number Address"}
            htmlFor={"customer-address1"}
          />
          <TextInput
            id={"customer-address1"}
            required
            variant="filled"
            value={generalInfo.address1}
            name={"address1"}
            onChange={handleChangeValue}
            readonly={isDetailPage}
            InputEndIcon={
              generalInfo?.address1 && (
                <CancelIcon
                  fontSize="small"
                  onClick={() =>
                    setGeneralInfo((pre) => ({ ...pre, address1: "" }))
                  }
                />
              )
            }
          />
        </Grid>
        {generalInfo?.address2 && (
          <Grid item xs={12} sm={12} md={6}>
            <Label
              title={"2nd Line of Phone Number Address"}
              htmlFor={"customer-address2"}
            />
            <TextInput
              id={"customer-address2"}
              required
              variant="filled"
              value={generalInfo.address2}
              readonly={true}
            />
          </Grid>
        )}

        {/* <Grid item xs={12} sm={6} md={3}>
          <Label title={"Town"} htmlFor={"customer-town"} />
          <TextInput
            id={"customer-town"}
            required
            variant="filled"
            value={generalInfo.town}
            name={"town"}
            onChange={handleChangeValue}
            readonly={isDetailPage || isAdmin}
          />
        </Grid> */}
        <Grid item xs={12} sm={6} md={3}>
          <Label title={"City"} htmlFor={"customer-city"} />
          <TextInput
            id={"customer-city"}
            variant="filled"
            value={generalInfo.city}
            name={"city"}
            onChange={handleChangeValue}
            readonly={isDetailPage}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Post Code"} htmlFor={"customer-postcode"} />
          <TextInput
            id={"customer-postcode"}
            required
            variant="filled"
            value={generalInfo.postCode}
            name={"postCode"}
            onChange={handleChangeValue}
            readonly={isDetailPage}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Stack mb={"7.5px"} direction={"row"} gap={1} alignItems={"flex-end"}>
            <CustomCheckBox
              isChecked={isBillingEmailSame}
              handleChecked={() => {
                if (!isDetailPage) {
                  setIsBillingEmailSame((pre) => !pre);
                }
              }}
            />
            <Label
              title={"Billing Email (Same as Customer Email)"}
              htmlFor={"customer-billing-email"}
              style={{ mb: 0, lineHeight: "normal" }}
            />
          </Stack>
          <TextInput
            id={"customer-billing-email"}
            required
            variant="filled"
            value={generalInfo.billingEmail}
            name={"billingEmail"}
            onChange={handleChangeValue}
            readonly={isDetailPage}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Stack mb={"7.5px"} direction={"row"} gap={1} alignItems={"flex-end"}>
            <CustomCheckBox
              isChecked={generalInfo.isAddCustomer}
              handleChecked={() => {
                if (!isDetailPage) {
                  setGeneralInfo((prev) => ({
                    ...prev,
                    isAddCustomer: !prev.isAddCustomer,
                    secondName:
                      prev.isAddCustomer === true ? "" : prev?.secondName,
                  }));
                }
              }}
            />
            <Label
              title={"Add Customer"}
              htmlFor={"add-name"}
              style={{ mb: 0, lineHeight: "normal" }}
            />
          </Stack>
          <TextInput
            id={"add-name"}
            readonly={isDetailPage}
            disabled={!generalInfo.isAddCustomer}
            required
            variant={"filled"}
            value={generalInfo.secondName}
            name={"secondName"}
            onChange={handleChangeValue}
          />
        </Grid>

        {/* <Grid item xs={12} sm={6} md={3}>
          <Label title={"E-Billing"} htmlFor={"e-billing"} />
          <CustomDropDown
            id={"e-billing"}
            variant={"filled"}
            value={generalInfo.eBilling}
            name={"eBilling"}
            onChange={handleChangeValue}
          >
            {["Yes", "No"].map((val, ind) => (
              <MenuItem key={ind} value={val}>
                {val}
              </MenuItem>
            ))}
          </CustomDropDown>
        </Grid> */}
      </Grid>
    </Box>
  );
};

export default memo(GeneralConnections);
